import { Text } from '@mxenabled/mxui'

import { Dialog, useGlobalCopyStore } from '../../../common'

interface MarkAsUnpaidDialogProps {
  isOpen: boolean
  onClose: () => void
  onUnlinkTransaction: () => void
}

export const MarkAsUnpaidDialog = ({
  isOpen,
  onClose,
  onUnlinkTransaction,
}: MarkAsUnpaidDialogProps) => {
  const { recurring: copy } = useGlobalCopyStore()

  return (
    <Dialog
      copy={{
        title: copy.mark_as_unpaid_dialog_title,
        close_aria: copy.close_drawer_aria,
      }}
      isOpen={isOpen}
      maxWidth="xs"
      onClose={onClose}
      onPrimaryAction={onUnlinkTransaction}
      primaryText={copy.unlink_transaction_button}
      sx={{
        '& .MuiStack-root, & .MuiDialogContent-root': {
          backgroundColor: 'background.paper',
        },
      }}
    >
      <Text truncate={false}>{copy.unlink_transaction_description}</Text>
    </Dialog>
  )
}
